import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import {
  faAlignLeft,
  faBullseyeArrow,
  faMoneyBillTrendUp,
  faSignal,
} from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'antd';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--height-base);
  height: var(--height-base);
  border-radius: var(--border-radius-small);
`;
const NavItem = styled.button<{ $isActive: boolean }>`
  padding: var(--spacing-03);
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    ${ContentWrapper} {
      background: var(--coolest-gray-10);
    }
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      ${ContentWrapper} {
        background: var(--gray-10);
      }
    `};
`;

export enum Sections {
  CurrentRisks = 'current_risks',
  OpportunityLog = 'opportunity_log',
  UserPage = 'user_page',
  Signals = 'signals',
}
export const getIcon = (section: Sections) => {
  switch (section) {
    case Sections.CurrentRisks:
      return faBullseyeArrow;
    case Sections.OpportunityLog:
      return faMoneyBillTrendUp;
    case Sections.UserPage:
      return faAlignLeft;
    case Sections.Signals:
      return faSignal;
  }
};

interface ContextSwitcherProps {
  activeSection: Sections;
  onSectionChange: (section: Sections) => void;
  userProfile: AccountPeopleProfile;
}
export const ContentNavigator = ({
  activeSection,
  onSectionChange,
  userProfile,
}: ContextSwitcherProps) => {
  return Object.values(Sections).map((section) => (
    <NavItem
      key={section}
      onClick={() => onSectionChange(section)}
      $isActive={activeSection === section}
    >
      <Tooltip
        title={
          <FormattedMessage
            id={`account.people.profile.sections.${section}.title`}
            values={{
              name: userProfile.user.firstName ?? userProfile.user.lastName,
            }}
          />
        }
        placement="left"
        key={section}
      >
        <ContentWrapper>
          <FontAwesomeIcon icon={getIcon(section)} />
        </ContentWrapper>
      </Tooltip>
    </NavItem>
  ));
};
